import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  OnInit,
  OnDestroy,
  inject
} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { forkJoin, Subscription, tap } from 'rxjs';
import { generateUUID } from 'src/app/core/generators/generateUUID';
import { IGetTipoCarreta } from 'src/app/services/TipoCarretaService/tipoCarreta.model';
import { TipoCarretaService } from 'src/app/services/TipoCarretaService/tipoCarreta.service';
import { formatarData, removeHyphen } from 'src/app/core/utils/utilities';
import {
  ICreateServicoEntrada,
  IGetServicosEntradaByCavalo,
  IGetServicosEntradaByGateEntrada,
  IUpdateServicoEntrada
} from 'src/app/services/ServicoEntradaService/servicoEntrada.model';
import { ServicoService } from 'src/app/services/ServicoService/servico.service';
import { CargaService } from 'src/app/services/CargaService/carga.service';
import { IGetServico } from 'src/app/services/ServicoService/servico.model';
import { IGetCarga } from 'src/app/services/CargaService/carga.model';
import { EntradaGateService } from 'src/app/services/EntradaGateService/entradaGate.service';
import { ServicoEntradaService } from 'src/app/services/ServicoEntradaService/servicoEntrada.service';
import Swal from 'sweetalert2';
import {
  ICreateServicoResponse,
  IGetServicoEntradaByIdResponse,
  IGetServicosEntradaByCavaloResponse
} from './cadastro-entrada-servicos.model';

type IOptions = {
  name: string;
  value: string | number;
};

@Component({
  selector: 'app-cadastro-entrada-servicos',
  templateUrl: './cadastro-entrada-servicos.component.html',
  styleUrls: ['./cadastro-entrada-servicos.component.scss']
})
export class CadastroEntradaServicosEmpresaComponent
  implements OnInit, AfterViewInit, OnDestroy
{
  private subscription$ = new Subscription();
  form: FormGroup;
  activeRoute: string = '';
  title: string = 'Entrada de Serviços';
  statusInput: boolean = false;
  isViewing: boolean = false;
  isEditing: boolean = false;
  isLoading: boolean = false;
  guid = generateUUID();

  private entradaGateService = inject(EntradaGateService);
  private servicoService = inject(ServicoService);
  private servicoEntradaService = inject(ServicoEntradaService);
  private tipoCarretaService = inject(TipoCarretaService);
  private tipoCargaService = inject(CargaService);

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private snackBar: MatSnackBar,
    private cd: ChangeDetectorRef,
    private route: ActivatedRoute,
    public dialog: MatDialog
  ) {
    this.form = this._inicializarFormulario();
  }

  ngOnInit(): void {
    this.activateRoute();
  }

  ngAfterViewInit(): void {}

  ngOnDestroy(): void {
    this.subscription$.unsubscribe();
  }

  servicoOptions: IOptions[] = [
    {
      name: '',
      value: ''
    }
  ];

  tipoCarretaOptions: IOptions[] = [
    {
      name: '',
      value: ''
    }
  ];

  tipoCargaOptions: IOptions[] = [
    {
      name: '',
      value: ''
    }
  ];

  tipoEixosOptions: IOptions[] = [
    {
      name: 'Até 6 Eixos',
      value: 1
    },
    {
      name: '7 Eixos',
      value: 2
    },
    {
      name: '9 Eixos',
      value: 3
    }
  ];

  qtdCompartimentosOptions: IOptions[] = [
    {
      name: '0',
      value: 0
    },
    {
      name: '1',
      value: 1
    },
    {
      name: '2',
      value: 2
    }
  ];

  tableColumns = [
    { header: 'Serviço', key: 'tipoServico', type: 'text' },
    { header: 'Cód. Serviço', key: 'servico', type: 'text' },
    { header: 'Tipo Carreta', key: 'tipoCarreta', type: 'text' },
    { header: 'Qtd. Eixos', key: 'quantidadeEixos', type: 'text' },
    {
      header: 'Qtd. Compart.',
      key: 'quantidadeCompartimentos',
      type: 'text'
    },
    { header: 'Tipo Carga', key: 'tipoCarga', type: 'text' },
    { header: 'Valor', key: 'valorServico', type: 'text' },
    { header: 'Operador', key: 'operador', type: 'text' },
    { header: 'Início Serviço', key: 'inicioServico', type: 'text' },
    { header: 'Entrada no Gate', key: 'gateEntrada', type: 'text' }
  ];

  tableData: Array<any> = [];

  private _inicializarFormulario() {
    const form = this.fb.group({
      TX_PLCA_CAVA: this.fb.control('', {
        nonNullable: true,
        validators: [Validators.required]
      }),
      DT_GATE_ENTR: this.fb.control(null, {
        nonNullable: true,
        validators: [Validators.required]
      }),
      DT_FILA: this.fb.control(null, {
        nonNullable: true,
        validators: [Validators.required]
      }),
      FK_GATE_ENTR: this.fb.control(null, {
        nonNullable: true,
        validators: [Validators.required]
      }),
      FK_SRVC: this.fb.control(null, {
        nonNullable: true,
        validators: [Validators.required]
      }),
      QT_CPTM: this.fb.control(0),
      FK_TIPO_CRRT: this.fb.control(null, {
        nonNullable: true,
        validators: [Validators.required]
      }),
      FK_CRGA: this.fb.control(null, {
        nonNullable: true,
        validators: [Validators.required]
      }),
      QT_TOTL_EIXO: this.fb.control(0, {
        nonNullable: true,
        validators: [Validators.required]
      }),
      TX_OBSV_SRVC_ENTR: this.fb.control(null, {
        nonNullable: true
      })
    });
    return form;
  }

  getEntrada() {
    if (this.form.controls['TX_PLCA_CAVA'].value.length !== 7) {
      return;
    }

    const payload = {
      placaCavalo: this.form.controls['TX_PLCA_CAVA'].value
    };

    this.isLoading = true;
    this.entradaGateService.GetEntradasGate(payload).subscribe({
      next: (response: any) => {
        this.isLoading = false;
        if (response.ITEMS.length > 0) {
          this.form.controls['FK_GATE_ENTR'].setValue(
            response.ITEMS[0].PK_GATE_ENTR
          );
          this.form.controls['DT_GATE_ENTR'].setValue(
            formatarData(response.ITEMS[0].DT_GATE_ENTR)
          );
          if (!this.isViewing) {
            this.getTabela();
          }
        }
      },
      error: () => {
        this.isLoading = false;
        this.exibirMensagem('Erro ao carregar as entradas', 'error');
      }
    });
  }

  getTabela() {
    if (!this.form.controls['FK_GATE_ENTR'].value) {
      return;
    }

    let params: IGetServicosEntradaByGateEntrada = { PK_GATE_ENTR: 0 };

    if (this.form.controls['FK_GATE_ENTR'].value) {
      params.PK_GATE_ENTR = this.form.controls['FK_GATE_ENTR'].value;
    }

    this.servicoEntradaService
      .GetServicosEntradaByGateEntrada(params)
      .subscribe({
        next: (response: IGetServicosEntradaByCavaloResponse[]) => {
          this.tableData = response.map(
            (item: IGetServicosEntradaByCavaloResponse) => {
              return {
                tipoServico: item.TX_TIPO_SRVC,
                servico: item.PK_SRVC_ENTR,
                tipoCarreta: item.NM_TIPO_CRRT ?? '---',
                quantidadeEixos: this.getQuantidadeEixos(item.QT_TOTL_EIXO),
                quantidadeCompartimentos: item.QT_CPTM,
                valorServico: item.VL_SRVC.toLocaleString('pt-BR', {
                  style: 'currency',
                  currency: 'BRL'
                }),
                tipoCarga: item.TX_CRGA ?? '---',
                operador: item.NM_OPER ?? '---',
                inicioServico: formatarData(item.DT_SRVC_ENTR),
                gateEntrada: formatarData(item.DT_GATE_ENTR)
              };
            }
          );
        },
        error: () => {
          this.exibirMensagem('Erro ao carregar os dados', 'error');
        }
      });
  }

  getServicoById(codigoGateEntrada: number) {
    this.servicoEntradaService.GetServicoById(codigoGateEntrada).subscribe({
      next: (response: IGetServicoEntradaByIdResponse) => {
        this.form.controls['FK_SRVC'].setValue(response.FK_SRVC);
        this.form.controls['FK_TIPO_CRRT'].setValue(response.FK_TIPO_CRRT);
        this.form.controls['FK_TIPO_CRRT'].setValue(response.FK_TIPO_CRRT);
        this.form.controls['QT_TOTL_EIXO'].setValue(response.QT_TOTL_EIXO);
        this.form.controls['QT_CPTM'].setValue(response.QT_CPTM ?? 0);
        this.form.controls['FK_CRGA'].setValue(response.FK_CRGA);
        this.form.controls['DT_GATE_ENTR'].setValue(
          formatarData(response.DT_GATE_ENTR ?? new Date())
        );
        this.form.controls['DT_FILA'].setValue(
          formatarData(response.DT_SRVC_ENTR ?? new Date())
        );
      },
      error: () => {
        this.exibirMensagem('Erro ao carregar os dados', 'error');
      }
    });
  }

  getSelects() {
    this.getServico();
    this.getTipoCarreta();
    this.getTipoCarga();
  }

  getServico() {
    this.isLoading = true;
    return this.servicoService.GetServico().pipe(
      tap(response => {
        this.isLoading = false;
        this.servicoOptions = response.map((x: IGetServico) => {
          return {
            name: x.TX_TIPO_SRVC,
            value: x.PK_SRVC
          };
        });
      })
    );
  }

  getTipoCarreta() {
    this.isLoading = true;
    return this.tipoCarretaService.GetTipoCarreta().pipe(
      tap(response => {
        this.isLoading = false;
        this.tipoCarretaOptions = response.map((x: IGetTipoCarreta) => {
          return {
            name: `${x.NM_TIPO_CRRT}`,
            value: x.PK_TIPO_CRRT
          };
        });
      })
    );
  }

  getTipoCarga() {
    this.isLoading = true;
    return this.tipoCargaService.GetCarga().pipe(
      tap(response => {
        this.isLoading = false;
        this.tipoCargaOptions = response.map((x: IGetCarga) => {
          return {
            name: `${x.TX_CRGA}`,
            value: x.PK_CRGA
          };
        });
      })
    );
  }

  atualizarCampo(campo: string, valor: any): void {
    if (this.form.controls[campo].value !== valor) {
      this.form.controls[campo].setValue(valor);
    }
  }

  escolherOpcao(campo: string, options: any[], value: any): void {
    const selecionado = options.find(opcao => opcao?.value === Number(value));

    this.atualizarCampo(campo, selecionado?.value);
  }

  escolherServico(value: any): void {
    this.escolherOpcao('FK_SRVC', this.servicoOptions, value);
  }

  escolherTipoCarreta(value: any): void {
    this.escolherOpcao('FK_TIPO_CRRT', this.tipoCarretaOptions, value);
  }

  escolherQuantidadeEixo(value: any): void {
    this.escolherOpcao('QT_TOTL_EIXO', this.tipoEixosOptions, value);
  }

  escolherCompartimento(value: any): void {
    this.escolherOpcao('QT_CPTM', this.qtdCompartimentosOptions, value);
  }

  escolherCarga(value: any): void {
    this.escolherOpcao('FK_CRGA', this.tipoCargaOptions, value);
  }

  exibirMensagem(mensagem: string, type: 'success' | 'error') {
    const config: MatSnackBarConfig = {
      duration: 3000,
      horizontalPosition: 'right',
      verticalPosition: 'top',
      panelClass: type === 'success' ? ['snackbar-success'] : ['snackbar-error']
    };

    this.snackBar.open(mensagem, 'Fechar', config);
  }

  goTo(route: string) {
    this.router.navigate([route]);
    setTimeout(() => {
      this.activeRoute = this.router.url;
      this.cd.detectChanges();
    }, 200);
  }

  setDataFila() {
    if (this.isEditing) {
      return;
    }
    this.form.controls['DT_FILA'].setValue(formatarData(new Date()));
  }

  activateRoute() {
    this.subscription$.add(
      forkJoin([
        this.getServico(),
        this.getTipoCarreta(),
        this.getTipoCarga()
      ]).subscribe(() => {
        this.form.controls['DT_FILA'].setValue(formatarData(new Date()));

        this.route.queryParams.subscribe(params => {
          if (
            (params['isEditing'] === 'true' ||
              params['isViewing'] === 'true') &&
            params['codigoGateEntrada']
          ) {
            this.title =
              params['isEditing'] === 'true'
                ? 'Editar Entrada de Serviço'
                : 'Visualização Entrada de Serviço';
            this.isEditing = params['isEditing'] === 'true';
            this.isViewing = params['isViewing'] === 'true';
            this.isViewing ? this.form.disable() : this.form.enable();

            this.form.controls['FK_GATE_ENTR'].setValue(
              +params['codigoGateEntrada']
            );
            this.form.controls['TX_PLCA_CAVA'].setValue(
              removeHyphen(params['placaCavalo'])
            );

            this.getServicoById(+params['codigoServico']);
            this.getEntrada();
            this.getTabela();
            return;
          }
        });
      })
    );
  }

  getQuantidadeEixos(value: number): string {
    switch (value) {
      case 1:
        return 'Até 6 Eixos';
      case 2:
        return '7 Eixos';
      case 3:
        return '9 Eixos';
      default:
        return '---';
    }
  }
}
